<div class="card mt-3">
  <p-toast></p-toast>

  <div class="card-header d-flex justify-content-between align-items-center">
    <strong>Instance #{{instance?.dripCampaignInstanceId}} — Detail</strong>
    <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-sm"
            title="Close" (click)="onClose()"></button>
  </div>

  <div *ngIf="loading" class="text-center p-4">
    <i class="pi pi-spin pi-spinner" style="font-size:2rem"></i>
  </div>

  <div *ngIf="!loading && detail" class="card-body">
    <!-- Summary -->
    <div class="row mb-3">
      <div class="col-md-3">
        <small class="text-muted d-block">Template</small>
        <span>Template #{{detail.dripCampaignTemplateId}}</span>
      </div>
      <div class="col-md-3">
        <small class="text-muted d-block">Entity</small>
        <ng-container *ngIf="getEntityRoute(); else noEntityLink">
          <a [routerLink]="getEntityRoute()" class="text-primary">
            {{getTaskSourceLabel(detail.taskSource)}} #{{detail.taskSourceId}}
          </a>
        </ng-container>
        <ng-template #noEntityLink>
          {{getTaskSourceLabel(detail.taskSource)}} #{{detail.taskSourceId}}
        </ng-template>
      </div>
      <div class="col-md-2">
        <small class="text-muted d-block">Status</small>
        <span class="badge"
              [ngClass]="{
                'badge-success': detail.status === 'ACTIVE',
                'badge-warning': detail.status === 'PAUSED',
                'badge-info': detail.status === 'COMPLETED',
                'badge-secondary': detail.status === 'COLD',
                'badge-danger': detail.status === 'CANCELLED'
              }">{{detail.status}}</span>
      </div>
      <div class="col-md-2">
        <small class="text-muted d-block">Current Step</small>
        <span>{{detail.currentStepOrder ?? '—'}}</span>
      </div>
      <div class="col-md-2">
        <small class="text-muted d-block">Next Step Date</small>
        <span>{{detail.nextStepDate ? (detail.nextStepDate | date:'MM/dd/yy HH:mm') : '—'}}</span>
      </div>
    </div>

    <div class="row mb-3" *ngIf="detail.initiatingTaskId">
      <div class="col-md-3">
        <small class="text-muted d-block">Initiating Task</small>
        <a [routerLink]="['/task-list']" [queryParams]="{taskId: detail.initiatingTaskId}" class="text-primary">
          Task #{{detail.initiatingTaskId}}
        </a>
      </div>
      <div class="col-md-3" *ngIf="detail.createDate">
        <small class="text-muted d-block">Created</small>
        <span>{{detail.createDate | date:'MM/dd/yy HH:mm'}}</span>
      </div>
    </div>

    <!-- Action buttons -->
    <div class="mb-3">
      <button *ngIf="detail.status === 'ACTIVE'" pButton type="button"
              label="Pause" icon="pi pi-pause"
              class="p-button-warning p-button-sm mr-2" (click)="onPause()"></button>
      <button *ngIf="detail.status === 'PAUSED'" pButton type="button"
              label="Resume" icon="pi pi-play"
              class="p-button-success p-button-sm mr-2" (click)="onResume()"></button>
      <button *ngIf="detail.status === 'ACTIVE' || detail.status === 'PAUSED'" pButton type="button"
              label="Cancel Campaign" icon="pi pi-ban"
              class="p-button-danger p-button-sm" (click)="onCancelPrompt()"></button>
    </div>

    <!-- Cancel confirm inline -->
    <div *ngIf="showCancelConfirm" class="alert alert-warning mb-3">
      <div class="form-group mb-2">
        <label>Reason (optional)</label>
        <textarea pInputTextarea [(ngModel)]="cancelReason" class="form-control" rows="2"
                  placeholder="Reason for cancellation"></textarea>
      </div>
      <button pButton type="button" label="Confirm Cancel" class="p-button-danger p-button-sm mr-2"
              (click)="confirmCancel()"></button>
      <button pButton type="button" label="Never mind" class="p-button-secondary p-button-sm"
              (click)="showCancelConfirm = false"></button>
    </div>

    <!-- Event log -->
    <h6 class="mt-3 mb-2">Event Log ({{events.length}})</h6>
    <p-table [value]="events" dataKey="dripCampaignEventId"
             styleClass="p-datatable-sm p-datatable-striped"
             responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th style="width:70px">Step</th>
          <th style="width:140px">Event Type</th>
          <th style="width:90px">Msg ID</th>
          <th style="width:90px">Task ID</th>
          <th>Details</th>
          <th style="width:130px">Date</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-ev>
        <tr>
          <td>{{ev.stepOrder}}</td>
          <td>{{ev.eventType}}</td>
          <td>
            <span *ngIf="ev.msgId">{{ev.msgId}}</span>
            <span *ngIf="!ev.msgId">—</span>
          </td>
          <td>
            <a *ngIf="ev.taskId" [routerLink]="['/task-list']"
               [queryParams]="{taskId: ev.taskId}" class="text-primary">{{ev.taskId}}</a>
            <span *ngIf="!ev.taskId">—</span>
          </td>
          <td>
            <span *ngIf="ev.eventDetails" [title]="ev.eventDetails">
              {{ev.eventDetails.length > 80 ? (ev.eventDetails | slice:0:80) + '...' : ev.eventDetails}}
            </span>
            <span *ngIf="!ev.eventDetails">—</span>
          </td>
          <td>{{ev.createDate | date:'MM/dd/yy HH:mm'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="6" class="text-center text-muted p-3">No events yet.</td></tr>
      </ng-template>
    </p-table>
  </div>
</div>
